type IconProps = React.SVGProps<SVGSVGElement>;

const TransactionError: React.FC<IconProps> = (props) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 52 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M25.9996 21.125V29.25M23.1868 8.1219L5.31661 38.9953C5.03066 39.4893 4.87987 40.0499 4.8794 40.6207C4.87892 41.1915 5.02879 41.7524 5.31392 42.2469C5.59905 42.7414 6.00938 43.152 6.50362 43.4376C6.99787 43.7231 7.55861 43.8734 8.1294 43.8734H43.8698C44.4406 43.8734 45.0013 43.7231 45.4955 43.4376C45.9898 43.152 46.4001 42.7414 46.6852 42.2469C46.9704 41.7524 47.1202 41.1915 47.1198 40.6207C47.1193 40.0499 46.9685 39.4893 46.6825 38.9953L28.8124 8.1219C28.5269 7.62867 28.1167 7.21919 27.623 6.93452C27.1293 6.64985 26.5695 6.5 25.9996 6.5C25.4297 6.5 24.8698 6.64985 24.3761 6.93452C23.8824 7.21919 23.4723 7.62867 23.1868 8.1219Z"
        stroke="currentColor"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M26 39C27.3462 39 28.4375 37.9087 28.4375 36.5625C28.4375 35.2163 27.3462 34.125 26 34.125C24.6538 34.125 23.5625 35.2163 23.5625 36.5625C23.5625 37.9087 24.6538 39 26 39Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default TransactionError;
